export default __webpack_public_path__ + "static/media/error.b6ae5b04.svg";